import StarIcon from "../assets/starIcon.svg";
import { useNavigate } from "react-router-dom";
import ShieldIcon from "../assets/shieldIcon.svg";
import PreviewImage from "../assets/previewBg.png";
import ZownIcon from "../assets/zown-logo-blue-wide.svg";
import ExpertGuidance from "../assets/expertGuidance.svg";
import CheckOnApplication from "../assets/checkOnApplication.svg";
import PreApprovalInMinutesIcon from "../assets/preApprovalInMinutes.svg";

interface BenefitProps {
  title: string;
  description: string;
  iconSrc: string;
}
const Benefit = ({ title, description, iconSrc }: BenefitProps) => (
  <div className="flex items-start gap-2">
    <img src={iconSrc} alt="" className="object-cover w-[25px] h-[25px]" />
    <div>
      <div className="font-semibold">{title}</div>
      <div className="text-[#9CA3AF]">{description}</div>
    </div>
  </div>
);

const PreviewView = () => {
  const navigate = useNavigate();
  return (
    <div className="absolute top-0 bottom-0 right-0 left-0 -inset-0 w-full h-full flex flex-col lg:flex-row text-[#32302F] bg-white">
      <div className="w-full h-full flex flex-col justify-center px-4 lg:px-10 space-y-10 py-10">
        <div className="space-y-4">
          <img src={ZownIcon} alt="" className="w-[106px]" />
          <div className="font-bold text-3xl">Home Begins Here</div>
          <div className="text-[#9CA3AF] font-light">
            Empowering you with the right mortgage options to make homeownership
            a reality
          </div>
        </div>
        <div className="space-y-4">
          <Benefit
            title="Pre-Approval in Minutes"
            description="Quick and easy approvals to get you moving faster."
            iconSrc={PreApprovalInMinutesIcon}
          />
          <Benefit
            title="One Application, Every Bank"
            description="Submit once, and we'll find the best rates from every major bank."
            iconSrc={CheckOnApplication}
          />
          <Benefit
            title="Expert Guidance at Every Step"
            description="We're with you from the first click to closing day."
            iconSrc={ExpertGuidance}
          />
        </div>
        <button
          onClick={() => navigate("/login/email")}
          type="button"
          className="rounded-full bg-z-prussian-blue text-white px-5 py-3 font-medium w-fit"
        >
          Get Started
        </button>
      </div>
      <div className="w-full h-full relative">
        <img
          src={PreviewImage}
          alt=""
          className="object-cover w-full h-full min-h-[557px]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#000000]/20 to-[#000000]/0" />
        <div className="w-full absolute bottom-10 px-4 lg:px-10 space-y-4 lg:space-y-6">
          <div className="text-white font-semibold text-xs lg:text-base max-w-[900px]">
            Working with Zown was so simple! The pre-approval process was quick
            and easy, and I always felt supported. They made everything so clear
            from start to finish, and before I knew it, I was securing my first
            home! I can't believe how seamless the experience was, so I'm glad I
            choose Zown.
          </div>
          <div className="flex items-center gap-4 h-full">
            <div>
              <div className="text-white font-bold ">Maria K.</div>
              <div className="text-[#D1D5DB] text-xs flex items-center gap-1">
                <img src={ShieldIcon} alt="ShieldIcon" />
                Verified Zown Review
              </div>
            </div>
            <div>
              <div className="text-white font-bold flex items-center gap-1">
                <img src={StarIcon} alt="StarIcon" />
                5.0
              </div>
              <div className="text-[#D1D5DB] text-xs">200+ Reviews</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export { PreviewView };
